module.exports = __webpack_public_path__ + "static/media/tnc-icon.79f073ee.svg";